const ITEMS = [
  "Bringing The Energy",
  "Unforgettable Nights",
  "High-Octane Sound",
  "Book QT 2hype For Your Next Event",
];

export default function Marquee() {
  return (
    <div data-testid="marquee" className="border-y border-white/10 bg-card2/60 py-5 overflow-hidden select-none">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex items-center shrink-0">
            {ITEMS.map((t, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span
                  className={`font-head font-extrabold uppercase tracking-tight text-2xl md:text-4xl px-6 ${
                    i % 2 === 0 ? "text-white" : "text-outline"
                  }`}
                >
                  {t}
                </span>
                <span className="text-volt font-head text-2xl md:text-4xl">///</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
